import { createStore } from "solid-js/store"
import { RevisionedCache, persisted } from "@/storage/persist"

/**
 * Disposable cache: the tunnel provider this browser last measured fastest for
 * each machine, so a new page starts there instead of moving to it once enough
 * samples arrive. Selection still verifies the route before relying on it.
 */
export function createRouteMemory() {
  const [store, setStore] = persisted(
    RevisionedCache.global("machine-fastest-routes"),
    createStore<{ fastest: Record<string, string | undefined> }>({ fastest: {} }),
  )
  return {
    fastest: (machine: string) => store.fastest[machine],
    remember: (machine: string, provider: string) => {
      if (store.fastest[machine] !== provider) setStore("fastest", machine, provider)
    },
    /** Prune only against a successfully loaded authoritative fleet snapshot. */
    retain: (machines: readonly string[]) => {
      const names = new Set(machines)
      for (const name of Object.keys(store.fastest)) {
        if (!names.has(name)) setStore("fastest", name, undefined)
      }
    },
  }
}
